import { createContext } from 'react'
import type { Context } from 'react'
import type { ProductStateType } from 'storeContext/reducers/product/types'
import type { ProductDispatchType } from 'storeContext/actions/product/bulkPrice'

export type ProductContextValueType = { state: ProductStateType; dispatch: ProductDispatchType }

// Preserve the existing raw-state default and Provider identity.
export const createProductContext = (initialState: ProductStateType) =>
  createContext(initialState) as unknown as Context<ProductContextValueType>
